export const EXPERIMENT_HOME_PAGE = {
    HOME_PAGE: 'Homepage_revamp'
};
